export default __webpack_public_path__ + "static/custom-made-7499c68d81a1594ed71114e1d8911a46.webp";